import React, { useLayoutEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import Refund from '@/pages/Refund';
import RefundDetail from '@/pages/RefundDetail';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import Login from '@/pages/Login';
import { loginUserState, updateUserInfo } from '@/store/modules/user';
import Home from '@/pages/Home';
import Medical from '@/pages/Medical';
import Notice from '@/pages/Notice';
import styled from 'styled-components';
import NoticeDetail from '@/components/notice/NoticeDetail';
import RefundStatement from '@/pages/RefundStatement';
import NotPage from '@/pages/NotPage';
import Redirect from '@/components/common/Redirect';
import KioskSetting from '@/pages/KioskSetting';
import AutoLogin from '@/pages/AutoLogin';
import SideNavigation from '@/components/sideNavigation';
import RefundDeparture from '@/pages/RefundDeparture';
import AdSetting from '@/pages/AdSetting';
import BookStatus from '@/pages/BookStatus';
import GlobalPayment from '@/pages/GlobalPayment';
import FXReceipt from '@/pages/FXReceipt';
import GlobalModal from '@/components/globalModal/GlobalModal';
import MedicalTourismApply from '@/pages/MedicalTourismApply';
import ImageViewer from '@/pages/ImageViewer';
import { routes } from '@/routes';
import Discount from '@/pages/Discount';
import DiscountDetail from '@/pages/DiscountDetail';

const RouterContainer = () => {
  const { isLogged, hospitals } = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const isMedicalTourismApplyPage =
    location.pathname === routes.medicalTourismApply;
  const isImageViewerPage = location.pathname === routes.imageViewer;
  useLayoutEffect(() => {
    if (localStorage.getItem('loginToken')) {
      dispatch(loginUserState(true));
    }
    // 초기값이 없을시 빈배열로 초기화
    if (!hospitals) {
      dispatch(updateUserInfo({ hospitals: [] }));
    }
  }, []);

  // // 263: 글로리의원 제주점, 220: 서울뉴라인의원, 325: 메이리의원
  // const EXCLUDED_HOSPITAL_IDS = [263, 220, 325];
  // const shouldShowGlobalModal = !EXCLUDED_HOSPITAL_IDS.includes(hospitalId);

  if (isMedicalTourismApplyPage) {
    return (
      <Routes>
        <Route
          path={routes.medicalTourismApply}
          element={<MedicalTourismApply />}
        />
      </Routes>
    );
  }

  if (isImageViewerPage) {
    return (
      <Routes>
        <Route path={routes.imageViewer} element={<ImageViewer />} />
      </Routes>
    );
  }

  if (isMobile) {
    return <NotPage />;
  }

  return (
    <>
      <Redirect />
      <Wrapper className='notranslate'>
        {isLogged && <SideNavigation />}
        {isLogged && <GlobalModal />}
        {isLogged ? (
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/refund' element={<Refund />} />
            <Route path='/refund-detail' element={<RefundDetail />} />
            <Route path='/refund-statement' element={<RefundStatement />} />
            <Route path='/refund-departure' element={<RefundDeparture />} />
            <Route path='/medical-info' element={<Medical />} />
            <Route path='/home/notice' element={<Notice />}></Route>
            <Route path='/home/notice/detail' element={<NoticeDetail />} />
            <Route path='/ad' element={<AdSetting />} />
            <Route path='/kiosk' element={<KioskSetting />} />
            <Route path='/auto-login' element={<AutoLogin />} />
            <Route path='/book-status' element={<BookStatus />} />
            <Route path='/global-payment' element={<GlobalPayment />} />
            <Route path='/fx-receipt' element={<FXReceipt />} />
            <Route path='/discount' element={<Discount />} />
            <Route path='/discount-detail' element={<DiscountDetail />} />
          </Routes>
        ) : (
          <Routes>
            <Route path='/' element={<Login />} />
            <Route path='/auto-login' element={<AutoLogin />} />
          </Routes>
        )}
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  display: flex;
  max-width: 100vw;
`;

export default RouterContainer;
